var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { label } from "../../typography";
import { bonfireGet } from "../../theme";
export var StyledLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  display: inline-block;\n  padding-bottom: 5px;\n  padding-left: ", ";\n  width: 100%;\n"], ["\n  ", ";\n  color: ", ";\n  display: inline-block;\n  padding-bottom: 5px;\n  padding-left: ", ";\n  width: 100%;\n"])), label, bonfireGet("colors", "textDark"), function (_a) {
    var $hasReadModeStyles = _a.$hasReadModeStyles;
    return $hasReadModeStyles ? "15px" : "0";
});
var templateObject_1;
//# sourceMappingURL=styled.js.map